import React from 'react';
import { Navigation } from '../components/Navigation';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { Footer } from '../components/Footer';

const WhyUsPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <WhyChooseUsSection />
      </div>
      <Footer />
    </div>
  );
};

export default WhyUsPage;
